import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { Button } from "@bidbattles/bloks/components/ui/button";
import { toast } from "sonner";
import { Copy01, RefreshCw01 } from "@untitledui/icons";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";

export function DefaultErrorComponent({
	error,
	info,
	reset,
}: ErrorComponentProps) {
	const router = useRouter();
	const queryErrorBoundary = useQueryErrorResetBoundary();

	return (
		<div className="flex flex-col gap-6 max-w-container w-full mx-auto px-box py-4">
			<p className="font-bold text-3xl lg:text-5xl">:(</p>
			<p className="font-bold text-2xl lg:text-4xl">Something went wrong</p>
			<p className="opacity-70">We encountered an error, apologies.</p>
			<div className="flex gap-4 flex-wrap">
				<Button
					size="sm"
					onClick={async () => {
						queryErrorBoundary.reset();
						router.invalidate();
						reset();
					}}
				>
					<RefreshCw01 stroke="currentColor" size="1em" />
					Try again
				</Button>
				<Button
					size="sm"
					variant="white"
					onClick={async () => {
						const errorData = {
							rawError: error,
							error: "message" in error ? error.message : String(error),
							stack: error.stack,
							cause: error.cause,
							info,
							userAgent: navigator.userAgent,
						};
						const encoded = JSON.stringify(errorData);

						await navigator.clipboard.writeText(encoded);
						toast.success("Copied to clipboard");
					}}
				>
					<Copy01 stroke="currentColor" size="1em" />
					Copy support info
				</Button>
			</div>
		</div>
	);
}
